import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}
export const Dialog = ({
  isOpen,
  onClose,
  children,
  title,
  size = 'lg'
}: DialogProps) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      document.body.style.overflow = 'hidden';
    } else {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 300);
      document.body.style.overflow = '';
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  if (!isVisible) return null;
  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl',
    full: 'max-w-full h-full'
  };
  return <div className={`fixed inset-0 z-50 flex items-center justify-center p-4 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'}`} data-id="element-1385">
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-1386"></div>
      <div className={`relative z-10 w-full ${sizeClasses[size]} bg-white border border-gray-200 rounded-lg shadow-lg transition-all duration-300 transform ${isOpen ? 'scale-100' : 'scale-95'}`} data-id="element-1387">
        <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-1388">
          <h2 className="text-lg font-medium" data-id="element-1389">{title}</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100" data-id="element-1390">
            <X size={20} data-id="element-1391" />
          </button>
        </div>
        <div className="p-4 overflow-auto max-h-[80vh]" data-id="element-1392">{children}</div>
      </div>
    </div>;
};